import { APP_SIGN_IN_URL, APP_SIGN_UP_URL } from "@/lib/appLinks";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const FinalCta = () => (
  <section className="bg-guinep-deep py-24 text-white sm:py-28">
    <div className="mx-auto max-w-3xl px-5 text-center sm:px-8">
      <Reveal>
        <h2 className="font-serif text-4xl font-medium leading-[1.1] tracking-tight sm:text-5xl lg:text-6xl">
          Less explaining. <em className="italic text-guinep-soft">Better enquiries.</em>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg">
          Give clients one place to see what you offer and what to do next.
        </p>
      </Reveal>
      <Reveal delay={0.18}>
        <div className="mt-9 flex flex-col items-center gap-5">
          <a
            href={APP_SIGN_UP_URL}
            data-testid="final-cta-create-page-button"
            className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-white px-8 py-4 text-base font-semibold text-guinep-deep transition-all duration-300 hover:bg-guinep-soft hover:shadow-[0_16px_40px_-12px_rgba(0,0,0,0.4)] sm:w-auto"
          >
            Create your Guinep Seed page
            <ArrowRight size={17} className="transition-transform duration-300 group-hover:translate-x-1" />
          </a>
          <a
            href={APP_SIGN_IN_URL}
            data-testid="final-cta-signin-button"
            className="text-sm font-medium text-white/70 underline-offset-4 transition-colors duration-300 hover:text-white hover:underline"
          >
            Already have a page? Sign in
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default FinalCta;
